import { Link } from "react-router-dom";
import { INSTAGRAM_URL, LINKEDIN_URL } from "../lib/brand";
import { NewsletterSignup } from "./NewsletterSignup";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-ink text-bg">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="lg:col-span-4">
            <p className="font-serif uppercase tracking-[0.14em] text-xl">Marella Bolognesi</p>
            <p className="mt-2 text-[11px] uppercase tracking-ultra text-bg/50">Miami, Florida</p>
          </div>

          {/* Links */}
          <div className="lg:col-span-2">
            <ul className="space-y-3 text-sm text-bg/80">
              <li><Link to="/services" className="link-underline" data-testid="footer-link-services">Estate Management</Link></li>
              <li><Link to="/salotto-digitale" className="link-underline" data-testid="footer-link-salotto">Il Salotto Digitale</Link></li>
              <li><Link to="/blog" className="link-underline" data-testid="footer-link-blog">Journal</Link></li>
              <li><Link to="/about" className="link-underline" data-testid="footer-link-about">About</Link></li>
              <li><Link to="/contact" className="link-underline" data-testid="footer-link-contact">Contact</Link></li>
              <li><Link to="/account" className="link-underline" data-testid="footer-link-library">My Library</Link></li>
            </ul>
          </div>

          {/* Social */}
          <div className="lg:col-span-2">
            <ul className="space-y-3 text-sm text-bg/80">
              <li><a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="link-underline" data-testid="footer-instagram">Instagram</a></li>
              {LINKEDIN_URL ? (
                <li><a href={LINKEDIN_URL} target="_blank" rel="noreferrer" className="link-underline" data-testid="footer-linkedin">LinkedIn</a></li>
              ) : (
                <li><span className="text-bg/40 cursor-default" title="LinkedIn coming soon" data-testid="footer-linkedin-placeholder">LinkedIn</span></li>
              )}
              <li><Link to="/contact" className="link-underline" data-testid="footer-email">Email</Link></li>
            </ul>
          </div>

          {/* Email signup */}
          <div className="lg:col-span-4">
            <NewsletterSignup source="footer" tone="dark" compact />
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-bg/15 flex flex-col sm:flex-row justify-between gap-4 text-[11px] uppercase tracking-[0.15em] text-bg/40">
          <span>© {new Date().getFullYear()} Marella Bolognesi</span>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <Link to="/privacy" className="link-underline hover:text-bg/70 transition-colors" data-testid="footer-link-privacy">Privacy</Link>
            <Link to="/terms" className="link-underline hover:text-bg/70 transition-colors" data-testid="footer-link-terms">Terms</Link>
            <Link to="/refund-policy" className="link-underline hover:text-bg/70 transition-colors" data-testid="footer-link-refund">Refunds</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
